module.exports = __webpack_public_path__ + "static/media/Undo.15c22083.svg";